import { defaultFillStyle } from 'ol/render/canvas';
import { asColorLike } from 'ol/colorlike';
import RegularShape from 'ol/style/RegularShape';

export class CustomShape extends RegularShape {

  #radius;

  constructor (options = {}) {
    super(options);
    this.#radius = options.radius ?? options.radius1;
  }

  getRadius () {
    return this.#radius;
  }

  /**
   * OL5 own method we're overriding here, it's *private* in OL5 hence the _ at the end
   *
   * @private
   * @param {RenderOptions} renderOptions - Render options.
   * @param {CanvasRenderingContext2D} context - The rendering context.
   * @param {number} x - The origin for the symbol (x).
   * @param {number} y - The origin for the symbol (y).
   */
  draw_ (renderOptions, context, x, y) {
    // reset transform
    context.setTransform(1, 0, 0, 1, 0, 0);

    // then move to path origin
    context.translate(x, y);

    if (renderOptions.strokeWidth) {
      context.translate(renderOptions.strokeWidth, renderOptions.strokeWidth);
    }

    this.drawPath(context);

    // fill and stroke like in RegularShape

    if (this.fill_) {
      let color = this.fill_.getColor();
      if (color === null) {
        color = defaultFillStyle;
      }
      context.fillStyle = asColorLike(color);
      context.fill();
    }
    if (this.stroke_) {
      context.strokeStyle = renderOptions.strokeStyle;
      context.lineWidth = renderOptions.strokeWidth;
      if (renderOptions.lineDash) {
        context.setLineDash(renderOptions.lineDash);
        context.lineDashOffset = renderOptions.lineDashOffset;
      }
      context.stroke();
    }
  }

  /**
   * Draw the shape path
   *
   * @protected
   * @param context - The rendering context
   */
  drawPath (context) { }

}
